var map = {
	"./accounting.svg": "5b0e",
	"./assets.svg": "04c4",
	"./base.svg": "0abb",
	"./branch.svg": "5ac8",
	"./contract.svg": "f260",
	"./customer.svg": "37d1",
	"./dashboard.svg": "187e",
	"./finance.svg": "bd33",
	"./post-loan.svg": "903a",
	"./potential-customers.svg": "12db",
	"./project.svg": "4bfd",
	"./repository.svg": "3210",
	"./template.svg": "69af",
	"./todo.svg": "e515"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d4e";